<span class="faq_badge badge rounded-circle bg-danger text-white border border-white" v-if="count &gt; 0" :id="badgeId"><span>{{ count }}</span></span>